document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;

  document.querySelectorAll('[data-cw-drawer-open]').forEach(btn => {
    btn.addEventListener('click', () => root.classList.add('cw-drawer-open'));
  });

  document.querySelectorAll('[data-cw-drawer-close]').forEach(btn => {
    btn.addEventListener('click', () => root.classList.remove('cw-drawer-open'));
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') root.classList.remove('cw-drawer-open');
  });

  /*
    Announcement bar message rotation is now 100% CSS (keyframes in
    sections/cw-announcement.liquid); only the countdown digits use JS, also
    inline in that section. There is intentionally NO announcement rotator here
    - a JS rotator previously fought the animation and snapped the bar back to
    message 1. Do not re-add one.
  */

  document.querySelectorAll('[data-cw-tabs]').forEach(tabWrap => {
    const buttons = Array.from(tabWrap.querySelectorAll('[data-cw-tab]'));
    const panels = Array.from(tabWrap.querySelectorAll('[data-cw-panel]'));

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.cwTab;
        buttons.forEach(btn => btn.classList.toggle('is-active', btn === button));
        panels.forEach(panel => panel.hidden = panel.dataset.cwPanel !== target);
      });
    });
  });

  document.querySelectorAll('[data-cw-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      /* Old hook. The product page now runs its own gallery script and its thumb
         buttons carry this attribute with no value, so an empty selector used to
         throw here on every tap. Do nothing unless a real selector is present. */
      const selector = button.dataset.cwProductThumb;
      if (!selector) return;
      const target = document.querySelector(selector);
      const img = button.querySelector('img');
      if (!target || !img) return;
      target.src = img.dataset.full || img.src;
      target.alt = img.alt || '';
    });
  });
});
